/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrderApproveCommand } from '../../models/order-approve-command';
import { OrderApproveCommandResult } from '../../models/order-approve-command-result';

export interface ApiNurseryManagerOrdersOrderApprovePost$Plain$Params {
      body?: OrderApproveCommand
}

export function apiNurseryManagerOrdersOrderApprovePost$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrdersOrderApprovePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderApproveCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrdersOrderApprovePost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrderApproveCommandResult>;
    })
  );
}

apiNurseryManagerOrdersOrderApprovePost$Plain.PATH = '/api/NurseryManager/Orders/OrderApprove';
